import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { dynamicFontSize, shadowOnHover } from './helpers/mixins';
import { color, animation } from './helpers/variables';

export const NavigationButtonContainer = styled(Link)`
  ${shadowOnHover};
  position: relative;
  width: 100%;
  min-height: 54px;
  background-color: ${color.white};
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  text-decoration: none;

  ${props =>
    props.mb &&
    css`
      margin-bottom: ${props.mb}px;
    `};
`;

export const NavigationButtonImage = styled.div`
  content: '';
  display: inline-block;
  min-width: 54px;
  height: 54px;
  background-image: url("${props => props.url}");
  background-size: cover;
  background-position: top left;

  @media screen and (min-width: 500px) {
    width: 72px;
    height: 72px;
  }
`;

export const NavigationButtonContent = styled.div`
  ${dynamicFontSize(12, 14, 320, 1360)};
  color: ${color.black};
  padding: 0 14px;
  font-weight: 600;
  letter-spacing: 2.5px;
  text-align: left;
  /* width: 100%; */
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: uppercase;
  min-height: inherit;

  @media screen and (min-width: 440px) {
    padding: 0 16px;
  }

  @media screen and (min-width: 520px) {
    padding: 0 18px;
  }

  @media screen and (min-width: 680px) {
    padding: 0 21px;
  }

  &:after {
    content: '';
    background-image: url('/images/icons/arrow.svg');
    background-size: contain;
    background-repeat: no-repeat;
    min-width: 14px;
    height: 14px;
    display: inline-block;
    margin-left: 5px;
    transform: rotateZ(-90deg);
    transition: transform ${animation.transitionTime} ${animation.easing};
  }

  &:hover:after {
    transform: translateX(4px) rotateZ(-90deg);
  }
`;



// WEBPACK FOOTER //
// ./src/styles/NavigationButton.js